<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">


    <div class="mt-1 d-flex justify-content-start align-items-center">

      <div class="proj_id d-flex">
        <div class="title_sub_div_1 ml-2" *ngIf="!fromProcurement"> Project Name : {{ this.projectName }} - Version :{{
          this.version_id
          }}</div>
        <div class="title_sub_div_1 ml-2" *ngIf="fromProcurement"> Project Name : {{ this.projectName }} - Procurement
          Version :{{ this.procurement_version_id
          }}</div>
      </div>

    </div>



    <!-- <div class="title_sub_div_1 title_right_icon_div mr-1">
      <i class="fa-solid fa-database " 
         title="Source"
         style="cursor:pointer"
         (click)="enableSourceEdit()">
      </i>

      <div *ngIf="finalConvertedData.length > 0" style="padding: 3px 0px;" class="btn mr-1"
        title="Export Supply Sense Data as Excel" (click)="exportData()">
        <i class="fas fa-file-export"></i>
      </div>
      <i class="fa fa-home" (click)="home()" title="Dashboard" style="margin-right: 5px;" style="color: black;"></i>
     
      <i class="fa fa-arrow-left" (click)="showRFQCheckboxes ? cancelRFQ() : back()"
        [title]="showRFQCheckboxes ? 'Back from RFQ' : 'Go on part view page'" style="color: black;">
      </i>
    </div> -->
    <div class="title_sub_div_1 title_right_icon_div mr-1 icon-bar">

      <i *ngIf="!isReviewStage && !showEditIcons && !showTriggerCheckboxes && !showDeleteCheckboxes" class="fa-solid fa-database icon-item" title="Source" (click)="enableSourceEdit()"></i>

      <i *ngIf="showTriggerSourcingBtn && !showTriggerCheckboxes && !showDeleteCheckboxes" class="fa-solid fa-bolt icon-item" title="Trigger Sourcing"
        (click)="enableTriggerMode()"></i>

      <i *ngIf="showTriggerSourcingBtn && !showTriggerCheckboxes && !showDeleteCheckboxes" class="fa-solid fa-trash-can icon-item" title="Delete Part"
        (click)="enableDeleteMode()" style="color: #dc2626;"></i>

      <ng-container *ngIf="showTriggerCheckboxes">
        <div class="trigger-controls">
          <button class="trigger-btn btn btn-outline-warning btn-sm"
            [title]="!isCriteriaSelected ? 'Please select sourcing criteria first' : 'Trigger Sourcing for selected parts'"
            [disabled]="getTriggerSelectedCount() === 0 || !isCriteriaSelected || isTriggerSourcing" (click)="triggerSourcingForSelected()">
            <span *ngIf="isTriggerSourcing" class="spinner-border spinner-border-sm me-1" role="status"></span>
            <i *ngIf="!isTriggerSourcing" class="fa-solid fa-bolt me-1"></i>
            Trigger <span *ngIf="isCriteriaSelected && getTriggerSelectedCount() > 0" class="trigger-count">({{ getTriggerSelectedCount() }})</span>
          </button>

          <button class="trigger-btn btn btn-outline-secondary btn-sm" title="Cancel Trigger"
            (click)="cancelTriggerMode()">
            <i class="fa-solid fa-xmark"></i>
          </button>

          <div class="trigger-extra" *ngIf="getTriggerSelectedCount() > 0">
            <i class="fa-solid fa-list-check icon-item trigger-icon" [class.text-success]="isCriteriaSelected"
              title="Criteria" (click)="selectCriteria(criteriaModal)"></i>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showDeleteCheckboxes">
        <div class="trigger-controls">
          <button class="trigger-btn btn btn-outline-danger btn-sm"
            title="Delete selected parts"
            [disabled]="getDeleteSelectedCount() === 0 || isDeletingParts || isLoading" (click)="deleteSelectedParts()">
            <span *ngIf="isDeletingParts" class="spinner-border spinner-border-sm me-1" role="status"></span>
            <i *ngIf="!isDeletingParts" class="fa-solid fa-trash-can me-1"></i>
            Delete <span *ngIf="getDeleteSelectedCount() > 0" class="trigger-count">({{ getDeleteSelectedCount() }})</span>
          </button>

          <button class="trigger-btn btn btn-outline-secondary btn-sm" title="Cancel Delete"
            (click)="cancelDeleteMode()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </ng-container>

      <div *ngIf="!showTriggerCheckboxes && !showDeleteCheckboxes && finalConvertedData.length > 0 && !showEditIcons" class="icon-item"
        title="Export Supply Sense Data" (click)="openExportModal(exportFormatModal)">
        <i class="fas fa-file-export"></i>
      </div>
      <div *ngIf="!showTriggerCheckboxes && !showDeleteCheckboxes && showEditIcons" class="icon-item" title="Add New Part"
        (click)="openAddPartModal(addPartModal)">
        <i class="fa-solid fa-plus"></i>
      </div>


      <i *ngIf="!showTriggerCheckboxes && !showDeleteCheckboxes" class="fa fa-home icon-item" title="Dashboard" (click)="home()"></i>

      <i *ngIf="!showTriggerCheckboxes && !showDeleteCheckboxes" class="fa fa-arrow-left icon-item"
        [title]="showRFQCheckboxes ? 'Back from RFQ' : (showEditIcons ? 'Back from Edit' : 'Go on part view page')"
        (click)="showRFQCheckboxes ? cancelRFQ() : back()"></i>

    </div>

  </div>
</div>
<ng-template #addPartModal let-modal>
  <div class="add-part-modal-header">
    <div class="add-part-modal-icon-wrap">
      <i class="fa-solid fa-plus"></i>
    </div>
    <div>
      <h6 class="add-part-modal-title">Add New Part</h6>
      <p class="add-part-modal-subtitle">Choose how you want to add data</p>
    </div>
    <button type="button" class="add-part-close-btn" (click)="modal.dismiss()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="add-part-modal-body">
    <div class="add-part-option-card" (click)="openUploadModal(uploadFileModal); modal.close()">
      <div class="add-part-option-icon upload-icon">
        <i class="fa-solid fa-file-arrow-up"></i>
      </div>
      <div class="add-part-option-text">
        <span class="add-part-option-label">Upload File</span>
        <span class="add-part-option-desc">Import from Sourcing List or AVD Excel</span>
      </div>
      <i class="fa-solid fa-chevron-right add-part-chevron"></i>
    </div>

    <div class="add-part-option-card" (click)="openManualAddModal(manualAddModal); modal.close()">
      <div class="add-part-option-icon manual-icon">
        <i class="fa-solid fa-keyboard"></i>
      </div>
      <div class="add-part-option-text">
        <span class="add-part-option-label">Add Manually</span>
        <span class="add-part-option-desc">Enter part details directly using form</span>
      </div>
      <i class="fa-solid fa-chevron-right add-part-chevron"></i>
    </div>
  </div>
</ng-template>

<ng-template #criteriaModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper">
        <i class="fas fa-sliders-h"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Sourcing Criteria</h5>
        <p class="criteria-modal-subtitle">Configure ranking & filtering preferences</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="closeModal()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-check-double" style="color: #3b82f6; font-size: 13px;"></i>
        <span>Selection Criteria</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="criteria.stockAvailability">
          <input type="checkbox" [(ngModel)]="criteria.stockAvailability" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-warehouse" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Stock Availability</span>
            <span class="criteria-option-hint">Prefer in-stock parts</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="criteria.stockAvailability ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.leadTime">
          <input type="checkbox" [(ngModel)]="criteria.leadTime" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-shipping-fast" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Lead Time</span>
            <span class="criteria-option-hint">Prioritize faster delivery</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.leadTime ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.minimumPrice">
          <input type="checkbox" [(ngModel)]="criteria.minimumPrice" hidden />
          <div class="criteria-option-icon" style="background: rgba(245, 158, 11, 0.1);">
            <i class="fas fa-tags" style="color: #f59e0b;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Minimum Price</span>
            <span class="criteria-option-hint">Rank by lowest cost</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas" [ngClass]="criteria.minimumPrice ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="criteria.authorisedSuppliers">
          <input type="checkbox" [(ngModel)]="criteria.authorisedSuppliers" hidden />
          <div class="criteria-option-icon" style="background: rgba(124, 58, 237, 0.1);">
            <i class="fas fa-shield-alt" style="color: #7c3aed;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Authorised Suppliers</span>
            <span class="criteria-option-hint">Only verified suppliers</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="criteria.authorisedSuppliers ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>

    <div class="criteria-section" style="margin-top: 14px;">
      <div class="criteria-section-label">
        <i class="fas fa-user-check" style="color: #7c3aed; font-size: 13px;"></i>
        <span>Supplier Selection</span>
      </div>
      <ng-select [items]="supplierOptions" [(ngModel)]="criteria.selectedSuppliers" (change)="onSupplierSelectionChange()" [multiple]="true" bindLabel="name"
        bindValue="name" class="custom-supplier-ng-select"
        [placeholder]="criteria.selectedSuppliers?.length ? '' : 'Search and select suppliers...'">
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="custom-supplier-selected">{{ item.name || item }}</span>
          <i class="mdi mdi-close-circle-outline custom-supplier-clear-icon" (click)="clear(item)"></i>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="criteria-btn-secondary" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="criteria-btn-primary" (click)="saveModal()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save Criteria
    </button>
  </div>
</ng-template>
<ng-template #dataPrefModal let-modal>
  <!-- Header -->
  <div class="criteria-modal-header"
    style="background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%); border-bottom: 1px solid #fed7aa;">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper" style="background: linear-gradient(135deg, #f59e0b, #d97706);">
        <i class="fas fa-database"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Data Preference</h5>
        <p class="criteria-modal-subtitle">Choose sourcing data sources</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="criteria-modal-body">
    <div class="criteria-section">
      <div class="criteria-section-label">
        <i class="fas fa-layer-group" style="color: #f59e0b; font-size: 13px;"></i>
        <span>Source Type</span>
      </div>
      <div class="criteria-options-grid">
        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('nexar')">
          <input type="checkbox" [checked]="dataPreference.includes('nexar')"
            (change)="onDataPrefChange('nexar', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(59, 130, 246, 0.1);">
            <i class="fas fa-globe" style="color: #3b82f6;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Consolidator</span>
            <span class="criteria-option-hint">Online marketplace data</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="dataPreference.includes('nexar') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>

        <label class="criteria-option" [class.criteria-option-active]="dataPreference.includes('vendor')">
          <input type="checkbox" [checked]="dataPreference.includes('vendor')"
            (change)="onDataPrefChange('vendor', $event.target.checked)" hidden />
          <div class="criteria-option-icon" style="background: rgba(16, 185, 129, 0.1);">
            <i class="fas fa-handshake" style="color: #10b981;"></i>
          </div>
          <div class="criteria-option-text">
            <span class="criteria-option-name">Direct</span>
            <span class="criteria-option-hint">Direct vendor sourcing</span>
          </div>
          <div class="criteria-option-toggle">
            <i class="fas"
              [ngClass]="dataPreference.includes('vendor') ? 'fa-toggle-on text-success' : 'fa-toggle-off text-muted'"
              style="font-size: 20px;"></i>
          </div>
        </label>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="criteria-modal-footer">
    <button type="button" class="criteria-btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="criteria-btn-primary" (click)="saveDataPreference()">
      <i class="fas fa-save" style="font-size: 12px;"></i>
      Save
    </button>
  </div>
</ng-template>
<ng-template #manualAddModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Add Part Manually</h6>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row g-2">

      <div class="col-md-6">
        <label>Internal Part No</label>
        <input class="form-control form-control-sm" [(ngModel)]="newPart.internalPartNo">
      </div>

      <div class="col-md-6">
        <label>MPN</label>
        <input class="form-control form-control-sm" [(ngModel)]="newPart.MPN">
      </div>

      <div class="col-md-6">
        <label>Description</label>
        <input class="form-control form-control-sm" [(ngModel)]="newPart.description">
      </div>

      <!-- <div class="col-md-6">
        <label>Make</label>
        <input class="form-control form-control-sm"
               [(ngModel)]="newPart.manufacturer">
      </div> -->
      <div class="col-md-6 position-relative make-dropdown-container">
        <label>Make</label>

        <input class="form-control form-control-sm" [(ngModel)]="newPart.manufacturer"
          (input)="searchManufacturerAPI(newPart.manufacturer)" (focus)="searchManufacturerAPI(newPart.manufacturer)"
          (blur)="onMakeBlur()" [ngClass]="{'border-danger': isMakeInvalid}" autocomplete="off">

        <!-- Loader -->
        <div *ngIf="isLoadingMake" class="text-muted small mt-1">
          Searching...
        </div>

        <!-- Dropdown -->
        <ul class="dropdown-menu show make-dropdown w-100" *ngIf="showMakeDropdown">
          <li *ngFor="let make of manufacturerMatches" class="dropdown-item cursor-pointer"
            (mousedown)="selectManufacturers(make)"
            (click)="selectManufacturers(make)">
            {{ make }}
          </li>
        </ul>
      </div>


      <div class="col-md-6">
        <label>Commodity</label>
        <input class="form-control form-control-sm" [(ngModel)]="newPart.commodity">
      </div>

      <div class="col-md-3">
        <label>UOM</label>
        <input class="form-control form-control-sm" [(ngModel)]="newPart.uom">
      </div>

      <div class="col-md-3">
        <label>Quantity</label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="newPart.projectQty">
      </div>
      <i class="fa-solid fa-list-check cursor-pointer" title="Criteria" (click)="selectCriteria(criteriaModal)">
      </i>

      <!-- Data Preference -->
      <i class="fa-solid fa-sliders text-success cursor-pointer" title="Data Preference" (click)="Data(dataPrefModal)">
      </i>

    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary btn-sm" (click)="modal.dismiss()">Cancel</button>

    <!-- <button class="btn btn-outline-primary btn-sm"
            (click)="saveManualPart(); modal.close()">
      Add
    </button> -->
    <button class="btn btn-outline-primary btn-sm" [disabled]="!isManualAddValid()"
      (click)="saveManualPart(); modal.close()">
      Add
    </button>

  </div>
</ng-template>
<ng-template #uploadFileModal let-modal>
  <div class="upload-modal-header">
    <div class="upload-modal-icon-wrap">
      <i class="fa-solid fa-cloud-arrow-up"></i>
    </div>
    <div>
      <h6 class="upload-modal-title">Upload Files</h6>
      <p class="upload-modal-subtitle">Upload sourcing list and alternate vendor data to compare</p>
    </div>
    <button type="button" class="upload-modal-close-btn" (click)="closeUploadModal()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div *ngIf="headerErrorMessage" class="upload-error-bar">
    <i class="fa-solid fa-triangle-exclamation me-1"></i>
    {{ headerErrorMessage }}
    <button type="button" *ngIf="isHeaderMappingRequired && sourceListData.length > 0"
      class="btn btn-sm btn-outline-primary ms-2" [disabled]="!sourcingListFileName"
      (click)="openHeaderMappingModal(mappingModal)" title="Open mapping popup">
      Configure
    </button>
  </div>

  <div class="upload-modal-body">

    <!-- Sourcing List Card -->
    <div class="upload-file-card" [class.upload-file-card--filled]="sourcingListFileName">
      <div class="upload-file-card-header">
        <div class="upload-file-icon blue-icon">
          <i class="fa-solid fa-table-list"></i>
        </div>
        <div class="upload-file-card-info">
          <span class="upload-file-card-title">Sourcing List</span>
          <span class="upload-file-sample-link" (click)="sourcingData()" title="Download Sample Sourcing List">
            <i class="fa-solid fa-download"></i> Download Sample
          </span>
        </div>
      </div>
      <div class="upload-drop-zone" (click)="upload_input.click()"
        [class.upload-drop-zone--filled]="sourcingListFileName">
        <input #upload_input type="file" class="file-input" hidden (change)="uploadSourcingListFiles($event)">
        <ng-container *ngIf="!sourcingListFileName">
          <i class="fa-solid fa-cloud-arrow-up upload-drop-icon"></i>
          <span class="upload-drop-text">Click to upload sourcing file</span>
          <span class="upload-drop-hint">.xlsx, .xls supported</span>
        </ng-container>
        <ng-container *ngIf="sourcingListFileName">
          <i class="fa-solid fa-file-excel upload-drop-icon success-icon"></i>
          <span class="upload-drop-filename">{{ sourcingListFileName }}</span>
          <span class="upload-drop-status">Ready to compare</span>
        </ng-container>
      </div>
      <div *ngIf="sourceListData.length > 0" class="upload-card-footer">
        <button type="button" class="upload-clear-btn" [disabled]="!sourcingListFileName"
          (click)="clearSourcingListFiles()">
          <i class="fa-solid fa-xmark"></i> Clear
        </button>
      </div>
    </div>

    <ng-template #mappingModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title"> Please Map The Required Fields</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="uploadedHeaders.length > 0">
          <div *ngFor="let field of tableHeaders" class="form-group row align-items-center mb-2">
            <label class="col-md-4 font-weight-bold">{{ field.label }}</label>
            <div class="col-md-8">
              <select class="form-control" [(ngModel)]="reverseFieldMapping[field.key]" name="{{field.key}}">
                <option [ngValue]="null">-- Select Column from Upload --</option>
                <option *ngFor="let header of uploadedHeaders" [value]="header">
                  {{ header }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-outline-primary btn-sm mt-2" (click)="applyMappedData(); modal.close()">
          Apply Mapping</button>
      </div>
    </ng-template>

    <!-- AVD Card -->
    <div class="upload-file-card" [class.upload-file-card--filled]="alternatePartFileName">
      <div class="upload-file-card-header">
        <div class="upload-file-icon green-icon">
          <i class="fa-solid fa-list-check"></i>
        </div>
        <div class="upload-file-card-info">
          <span class="upload-file-card-title">Alternate Vendor List</span>
          <span class="upload-file-sample-link" (click)="alternateData()" title="Download Sample AVD">
            <i class="fa-solid fa-download"></i> Download Sample
          </span>
        </div>
      </div>
      <div class="upload-drop-zone" (click)="upload_file_input.click()"
        [class.upload-drop-zone--filled]="alternatePartFileName">
        <input #upload_file_input type="file" accept=".pdf,.xlsx" class="file-input" hidden
          (change)="handleFileUpload($event)">
        <ng-container *ngIf="!alternatePartFileName">
          <i class="fa-solid fa-cloud-arrow-up upload-drop-icon"></i>
          <span class="upload-drop-text">Click to upload AVD file</span>
          <span class="upload-drop-hint">.xlsx, .pdf supported</span>
        </ng-container>
        <ng-container *ngIf="alternatePartFileName">
          <i class="fa-solid fa-file-excel upload-drop-icon success-icon"></i>
          <span class="upload-drop-filename">{{ alternatePartFileName }}</span>
          <span class="upload-drop-status">Ready to compare</span>
        </ng-container>
      </div>
      <div *ngIf="avdData.length > 0" class="upload-card-footer">
        <button type="button" class="upload-clear-btn" [disabled]="!alternatePartFileName" (click)="clearAvdFiles()">
          <i class="fa-solid fa-xmark"></i> Clear
        </button>
      </div>
    </div>

  </div>

  <div class="upload-modal-footer">
    <button type="button" class="upload-btn-secondary" (click)="closeUploadModal()">Close</button>
    <button type="button" class="upload-btn-primary" (click)="finalData()" [disabled]="isLoading">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>
      <i *ngIf="!isLoading" class="fa-solid fa-code-compare me-1"></i>
      Compare Both Files
    </button>
  </div>
</ng-template>

<!-- FINAL PREVIEW: show when finalDataList has items -->
<div *ngIf="finalDataList.length > 0" class="row row_mar">
  <div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
      <div class="card-header d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <h6 class="card-title">Preview</h6>
        </div>
        <div class="d-flex justify-content-end">
          <button class="btn btn-light btn-sm" title="Export Data" (click)="openExportModal(exportFormatModal)">
            <i class="fas fa-file-export"></i> Export
          </button>
          <!-- <button class="btn btn-light btn-sm" title="Export sample preview" (click)="exportPreviewSample()">
            <i class="fas fa-download"></i> Export sample
          </button> -->
          <button type="button" class="btn btn-outline-primary btn-sm" title="Reset Final data"
            (click)="resetFinalData()">Reset</button>
          <button type="button" class="btn btn-sm" [ngClass]="isCriteriaSelected ? 'btn-success' : 'btn-outline-primary'" title="Criteria"
            (click)="selectCriteria(criteriaModal)">
            <i class="fa-solid fa-check me-1" *ngIf="isCriteriaSelected"></i>Criteria
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm" title="Data Preference"
            (click)="Data(dataPrefModal)">Data Preference</button>

          <button type="button" class="btn btn-outline-primary btn-sm" title="Upload data" [disabled]="!isUploadEnabled"
            (click)="uploadFinalData()">
            <span *ngIf="isUploading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Upload
          </button>
        </div>
      </div>

      <div class="card-body">
        <div class="table-responsive gd_main_div_mobile">
          <table class="table table-striped custom-hover">
            <thead>
              <tr>
                <th>S No</th>
                <th>Customer Part No. <i class="fa fa-chevron-down" (click)="toggleSearch(1)"></i></th>
                <th>Internal Part No. <i class="fa fa-chevron-down" (click)="toggleSearch(2)"></i></th>
                <th>Description <i class="fa fa-chevron-down" (click)="toggleSearch(3)"></i></th>
                <th>Specification <i class="fa fa-chevron-down" (click)="toggleSearch(4)"></i></th>
                <th>Commodity <i class="fa fa-chevron-down" (click)="toggleSearch(5)"></i></th>
                <th>Manufacturer <i class="fa fa-chevron-down" (click)="toggleSearch(6)"></i></th>
                <th>UOM <i class="fa fa-chevron-down" (click)="toggleSearch(7)"></i></th>
                <th>Project qty <i class="fa fa-chevron-down" (click)="toggleSearch(8)"></i></th>
                <th>I Sourcing <i class="fa fa-chevron-down" (click)="toggleSearch(9)"></i></th>
              </tr>
              <tr *ngIf="showSearch">
                <th></th>
                <th *ngFor="let col of tableHeaders; let i = index">
                  <input *ngIf="showSearchRow[i]" type="text" class="form-control form-control-sm"
                    [(ngModel)]="searchValues[i]" (input)="filterData()" placeholder="Search {{ col.label }}" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of finalDataList; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item?.customerPartNumber }}</td>
                <td>{{ item?.internalPartNo }}</td>
                <td>{{ item?.description }}</td>
                <td>{{ item?.specification }}</td>
                <td>{{ item?.commodity }}</td>
                <td *ngIf="item?.manufacturer">
                  <ng-container>
                    <button *ngIf="!isDropdownVisible[i]" style="font-size: 12px;"
                      [ngClass]="buttonColorMap[item.manufacturer] || 'btn-light'" class="btn btn-mfg ml-1"
                      [ngStyle]="{'border': buttonBorderStyle[i],'width': '150px'}"
                      (click)="toggleDropdownVisibility(item, i)">

                      {{ manufacturerOverrideMap[item.manufacturer] || item?.manufacturer }}
                    </button>

                    <select *ngIf="isDropdownVisible[i]" class="form-select form-select-sm manufacturer-dropdown"
                      (change)="onManufacturerChange($event, item, i)" [(ngModel)]="selectedManufacturerMap[i]">
                      <option *ngFor="let manufacturer of allManufacturerDetailsMap[i]" [value]="manufacturer">
                        {{ manufacturer }}
                      </option>
                    </select>

                  </ng-container>
                </td>
                <td>{{ item?.uom }}</td>
                <td>{{ item?.projectQty }}</td>
                <td>{{ item?.iSourcing }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-tab-group #tabGroup [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
  <mat-tab label="SOURCE BOARD">
    <div style="background-color: whitesmoke;">

      <ngx-analysis (currencySelected)="onCurrencySelected($event)" (partSelected)="onPartSelected($event)"
        (vendorSelected)="onVendorSelected($event)"></ngx-analysis>

    </div>
  </mat-tab>

  <mat-tab class="mat_class" label="SUPPLY SENSE">

    <div class="ss-toolbar">
      <!-- Left: Stat chips -->
      <div class="ss-toolbar__stats">

        <button type="button" class="ss-chip ss-chip--info" [class.ss-chip--active]="savedFilter === 'all'"
          title="Unique Parts" (click)="showAllPartsCount()">
          <i class="fa fa-cubes ss-chip__icon"></i>
          <span class="ss-chip__label">Parts</span>
          <span class="ss-chip__value">{{ uniquePartsCount }}</span>
        </button>

        <button type="button" class="ss-chip ss-chip--success" [class.ss-chip--active]="savedFilter === 'sourced'"
          title="Parts Except N/A" (click)="showSourcedParts()">
          <i class="fa fa-check-circle ss-chip__icon"></i>
          <span class="ss-chip__label">Sourced</span>
          <span class="ss-chip__value">{{ partsExceptNA }}</span>
        </button>

        <button type="button" class="ss-chip ss-chip--danger" [class.ss-chip--active]="savedFilter === 'unsourced'"
          title="Parts with N/A Supplier" (click)="showUnsourcedParts()">
          <i class="fa fa-exclamation-circle ss-chip__icon"></i>
          <span class="ss-chip__label">Unsourced</span>
          <span class="ss-chip__value">{{ partsNA }}</span>
        </button>

        <div class="ss-chip ss-chip--cost" title="Total Sum">
          <i class="fa fa-inr ss-chip__icon"></i>
          <span class="ss-chip__label">Project Cost</span>
          <span class="ss-chip__value">₹ {{ projectCost | number:'1.0-0' }}</span>
        </div>

      </div>

      <!-- Right: Action buttons -->
      <div class="ss-toolbar__actions">
        <button *ngIf="showMarkupButton && !isReviewStage" type="button" class="ss-action-btn ss-action-btn--outline"
          [class.ss-action-btn--active]="isMarkupMode" [title]="isAucukumServer ? 'Toggle Add landing cost' : 'Toggle mark-up columns'" (click)="toggleMarkupColumns()">
          <i *ngIf="!isAucukumServer" class="fa fa-percent ss-action-btn__icon"></i>{{ isAucukumServer ? 'Add landing cost' : 'Mark-up' }}
        </button>
        <button *ngIf="showMarkupButton && isMarkupMode" type="button" class="ss-action-btn ss-action-btn--outline"
          style="background-color: #dbeafe; color: #1d4ed8; border-color: #bfdbfe;" title="Upload Unit Selling Prices from Excel"
          (click)="priceUploadFileInput.click()">
          <i class="fa fa-upload ss-action-btn__icon"></i>Price upload
        </button>
        <input #priceUploadFileInput type="file" (change)="onPriceExcelUpload($event)" accept=".xlsx, .xls" style="display: none;" />
        <button *ngIf="showMarkupButton && isMarkupMode" type="button" class="ss-action-btn ss-action-btn--outline"
          style="background-color: #dcfce7; color: #15803d; border-color: #bbf7d0;" title="Save mark-up changes"
          [disabled]="isSavingMarkup || isLoading"
          (click)="saveMarkupChanges()">
          <i *ngIf="isSavingMarkup" class="fa fa-spinner fa-spin ss-action-btn__icon"></i>
          <i *ngIf="!isSavingMarkup" class="fa fa-save ss-action-btn__icon"></i>Save
        </button>
        <button *ngIf="showMarkupButton && isMarkupMode" type="button" class="ss-action-btn ss-action-btn--outline"
          style="background-color: #fee2e2; color: #b91c1c; border-color: #fecaca;" title="Cancel mark-up changes"
          [disabled]="isSavingMarkup || isLoading"
          (click)="cancelMarkupChanges()">
          <i class="fa fa-times ss-action-btn__icon"></i>Cancel
        </button>
        <button type="button" class="ss-action-btn ss-action-btn--outline" title="Send to GetAPcs"
          [disabled]="isSendingDetapics || isLoading"
          (click)="sendDetapics()">
          <i *ngIf="isSendingDetapics" class="fa fa-spinner fa-spin ss-action-btn__icon"></i>
          <i *ngIf="!isSendingDetapics" class="fa fa-paper-plane ss-action-btn__icon"></i> GetAPcs
        </button>

        <button type="button" class="ss-action-btn ss-action-btn--outline" title="Refresh table data"
          [disabled]="isLoading"
          (click)="getdata()">
          <i class="fa fa-refresh ss-action-btn__icon" [class.fa-spin]="isLoading"></i> Refresh
        </button>

        <button *ngIf="showFetch" type="button" class="ss-action-btn ss-action-btn--outline" title="Fetch Suppliers"
          (click)="fetchsuppliers()">
          <i class="fa fa-download ss-action-btn__icon"></i> Fetch Suppliers
        </button>

        <button type="button" class="ss-action-btn ss-action-btn--outline" title="Q-Sourcing Stat"
          (click)="QSourcing()">
          <i class="fa fa-bar-chart ss-action-btn__icon"></i> Q-Sourcing
        </button>

        <button *ngIf="!showFetch" type="button" class="ss-action-btn ss-action-btn--accent" title="Send RFQ"
          (click)="sendRFQ()">
          <i class="fa fa-paper-plane ss-action-btn__icon"></i> Send RFQ
        </button>

        <button *ngIf="projectStatus === 'Open'" type="button" class="ss-action-btn ss-action-btn--primary"
          [disabled]="completion_percentage !== 100"
          [title]="completion_percentage === 100 ? 'Submit' : 'Submit disabled until completion percentage is 100% (' + completion_percentage + '% completed)'"
          (click)="openPopup(offerPriceModal)">
          <i class="fa fa-check ss-action-btn__icon"></i> Submit
        </button>



      </div>
    </div>
    <div *ngIf="showEditConfirmPopup" class="custom-modal-backdrop">
      <div class="custom-modal custom-modal--edit">
        <div class="custom-modal__header">
          <div class="custom-modal__icon">
            <i class="fa-solid fa-pen-to-square"></i>
          </div>
          <div class="custom-modal__title-wrap">
            <h5 class="custom-modal__title">Edit current version?</h5>
            <p class="custom-modal__subtitle">Choose whether to update this version directly.</p>
          </div>
        </div>

        <div class="custom-modal__body">
          <p class="custom-modal__message">
            We recommend creating a duplicate version before making changes, so the existing data is preserved for
            future reference.
          </p>
        </div>

        <div class="custom-modal__footer">
          <button class="btn btn-outline-primary btn-sm px-4" (click)="confirmEditWithoutClone()">
            Edit without Clone
          </button>

          <button class="btn btn-outline-primary btn-sm px-4" (click)="cancelEditPopup()">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!--  Data In Progress Card -->
    <div *ngIf="isDataInProgress" class="sb-in-progress-card">
      <div class="sb-in-progress-spinner">
        <div class="spinner-border text-primary" style="width: 2.8rem; height: 2.8rem; border-width: 0.22em;" role="status"></div>
      </div>
      <h5 class="sb-in-progress-title">Data In-Progress</h5>
      <p class="sb-in-progress-desc">Processing part details and sourcing algorithms. Please wait a moment...</p>
      <div class="sb-loading-progress-bar">
        <div class="sb-loading-progress-indeterminate"></div>
      </div>
    </div>

    <div class="row row_mar mt-1">
      <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive gd_main_div_mobile">
              <table *ngIf="!isDataInProgress" class="table table-striped custom-hover">
                <thead>
                  <tr>
                    <!-- <th>
    
    </th> -->
                    <th>
                      <span *ngIf="showEditIcons">Edit</span>
                    </th>

                    <th *ngIf="showRFQCheckboxes">
                      <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection($event)" />
                    </th>
                    <th *ngIf="showTriggerCheckboxes">
                      <input type="checkbox" [checked]="isTriggerAllSelected()"
                        (change)="toggleTriggerAllSelection($event)" />
                    </th>
                    <th *ngIf="showDeleteCheckboxes">
                      <input type="checkbox" [checked]="isDeleteAllSelected()"
                        (change)="toggleDeleteAllSelection($event)" />
                    </th>
                    <th (click)="sortData('internalPartNo')" class="sortable-header">
                      Internal Part No
                      <i [ngClass]="getSortIcon('internalPartNo')"></i>
                    </th>
                    <th (click)="sortData('specification')" class="sortable-header">
                      MPN
                      <i [ngClass]="getSortIcon('specification')"></i>
                    </th>
                    <th (click)="sortData('MPN')" class="sortable-header">
                      MPN(Match)
                      <i [ngClass]="getSortIcon('MPN')"></i>
                    </th>
                    <th class="searchable-header" (click)="toggleHeaderSearch('manufacturer', $event)">
                      <div *ngIf="!isSearchOpen.manufacturer" class="header-title-wrap">
                        <span>Make <small *ngIf="searchFilters.manufacturer" class="text-primary fw-bold">({{ searchFilters.manufacturer }})</small></span>
                        <i class="fa fa-search header-search-icon"
                          [class.active]="searchFilters.manufacturer"
                          title="Search Make"></i>
                      </div>
                      <div *ngIf="isSearchOpen.manufacturer" class="header-search-wrap" (click)="$event.stopPropagation()">
                        <input id="header-search-manufacturer" type="text" class="form-control form-control-sm header-search-input"
                          placeholder="Search Make..." [(ngModel)]="searchFilters.manufacturer"
                          (input)="applySupplySenseFilters()" (keydown.enter)="closeHeaderSearch('manufacturer')" (keydown.escape)="clearHeaderSearch('manufacturer', $event)" />
                        <i class="fa fa-times header-search-clear" (click)="clearHeaderSearch('manufacturer', $event)" title="Clear & Close"></i>
                      </div>
                    </th>
                    <th class="searchable-header" (click)="toggleHeaderSearch('commodity', $event)">
                      <div *ngIf="!isSearchOpen.commodity" class="header-title-wrap">
                        <span>Commodity <small *ngIf="searchFilters.commodity" class="text-primary fw-bold">({{ searchFilters.commodity }})</small></span>
                        <i class="fa fa-search header-search-icon"
                          [class.active]="searchFilters.commodity"
                          title="Search Commodity"></i>
                      </div>
                      <div *ngIf="isSearchOpen.commodity" class="header-search-wrap" (click)="$event.stopPropagation()">
                        <input id="header-search-commodity" type="text" class="form-control form-control-sm header-search-input"
                          placeholder="Search Commodity..." [(ngModel)]="searchFilters.commodity"
                          (input)="applySupplySenseFilters()" (keydown.enter)="closeHeaderSearch('commodity')" (keydown.escape)="clearHeaderSearch('commodity', $event)" />
                        <i class="fa fa-times header-search-clear" (click)="clearHeaderSearch('commodity', $event)" title="Clear & Close"></i>
                      </div>
                    </th>
                    <th (click)="sortData('uom')" class="sortable-header">
                      UOM
                      <i [ngClass]="getSortIcon('uom')"></i>
                    </th>
                    <th (click)="sortData('projectQty')" class="sortable-header">
                      Quantity
                      <i [ngClass]="getSortIcon('projectQty')"></i>
                    </th>
                    <th class="searchable-header" (click)="toggleHeaderSearch('supplier', $event)">
                      <div *ngIf="!isSearchOpen.supplier" class="header-title-wrap">
                        <span>Finalized Supplier <small *ngIf="searchFilters.supplier" class="text-primary fw-bold">({{ searchFilters.supplier }})</small></span>
                        <i class="fa fa-search header-search-icon"
                          [class.active]="searchFilters.supplier"
                          title="Search Finalized Supplier"></i>
                      </div>
                      <div *ngIf="isSearchOpen.supplier" class="header-search-wrap" (click)="$event.stopPropagation()">
                        <input id="header-search-supplier" type="text" class="form-control form-control-sm header-search-input"
                          placeholder="Search Supplier..." [(ngModel)]="searchFilters.supplier"
                          (input)="applySupplySenseFilters()" (keydown.enter)="closeHeaderSearch('supplier')" (keydown.escape)="clearHeaderSearch('supplier', $event)" />
                        <i class="fa fa-times header-search-clear" (click)="clearHeaderSearch('supplier', $event)" title="Clear & Close"></i>
                      </div>
                    </th>
                    <th></th>
                    <th (click)="sortData('country')" class="sortable-header">
                      COP
                      <i [ngClass]="getSortIcon('country')"></i>
                    </th>
                    <th (click)="sortData('Inventorylevel')" class="sortable-header">
                      Stock
                      <i [ngClass]="getSortIcon('Inventorylevel')"></i>
                    </th>
                    <th (click)="sortData('MOQ')" class="sortable-header">
                      MOQ
                      <i [ngClass]="getSortIcon('MOQ')"></i>
                    </th>
                    <th (click)="sortData('Closest_Quantity')" class="sortable-header">
                      SPQ
                      <i [ngClass]="getSortIcon('Closest_Quantity')"></i>
                    </th>
                    <th (click)="sortData('leadTime')" class="sortable-header">
                      Lead Time
                      <i [ngClass]="getSortIcon('leadTime')"></i>
                    </th>
                    <th (click)="sortData('Price')" class="sortable-header">
                      Basic Price
                      <i [ngClass]="getSortIcon('Price')"></i>
                    </th>
                    <th (click)="sortData('Currency')" class="sortable-header">
                      Currency
                      <i [ngClass]="getSortIcon('Currency')"></i>
                    </th>
                    <th (click)="sortData('ConvertedPrice')" class="sortable-header">
                      Basic Price (INR)
                      <i [ngClass]="getSortIcon('ConvertedPrice')"></i>
                    </th>
                    <th *ngIf="!isAucukumServer" (click)="sortData('landing_cost')" class="sortable-header">
                      Est.Landing Cost
                      <i [ngClass]="getSortIcon('landing_cost')"></i>
                    </th>
                    <th *ngIf="!isAucukumServer" (click)="sortData('moqCost')" class="sortable-header">
                      MOQ Cost
                      <i [ngClass]="getSortIcon('moqCost')"></i>
                    </th>
                    <th *ngIf="!isAucukumServer" (click)="sortData('total_value_inr')" class="sortable-header">
                      Total Cost (INR)
                      <i [ngClass]="getSortIcon('total_value_inr')"></i>
                    </th>
                    <th *ngIf="showPercentColumns && !isNgpInstance" (click)="sortData('profitMargin')" class="sortable-header">
                      % Profit Margin
                      <i [ngClass]="getSortIcon('profitMargin')"></i>
                    </th>
                    <th *ngIf="showPercentColumns" (click)="sortData('unitSellingPrice')" class="sortable-header">
                      Unit Selling Price
                      <i [ngClass]="getSortIcon('unitSellingPrice')"></i>
                    </th>
                    <th *ngIf="showPercentColumns" (click)="sortData('totalSellingValue')" class="sortable-header">
                      Total Selling Value
                      <i [ngClass]="getSortIcon('totalSellingValue')"></i>
                    </th>
                    <th (click)="sortData('isPoExist')" class="sortable-header">
                      PO History
                      <i [ngClass]="getSortIcon('isPoExist')"></i>
                    </th>
                    <th>Risk (Inv,LT,Price)</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let row of filteredData; let i = index"
                    [ngClass]="{'highlight-row': row.internalPartNo === highlightedIPN}"
                    [ngStyle]="highlightNA && row?.supplier  === 'N/A' ? {'background-color': '#ffff99'} : {}">
                    <td>
                      <i *ngIf="showEditIcons && editingRow !== row" class="fa fa-pencil-alt circle-icon edit "
                        title="Edit" style="cursor:pointer" (click)="startRowEdit(row, i)">
                      </i>
                    </td>

                    <td *ngIf="showRFQCheckboxes">
                      <input type="checkbox" [checked]="rfqSelected[row.internalPartNo]"
                        (change)="onRFQCheckboxChange(row, $event)" />
                    </td>
                    <td *ngIf="showTriggerCheckboxes">
                      <input type="checkbox" [checked]="triggerSelected[row.internalPartNo]"
                        (change)="onTriggerCheckboxChange(row, $event)" />
                    </td>
                    <td *ngIf="showDeleteCheckboxes">
                      <input type="checkbox" [checked]="deleteSelected[row.internalPartNo]"
                        (change)="onDeleteCheckboxChange(row, $event)" />
                    </td>
                    <!-- [disabled]="row.supplier === 'N/A'" -->
                    <td class="col-ipns partNo_td" style="cursor: pointer; color: #0066cc; text-decoration: underline;"
                      (click)="onPartInfo(row)">{{ row?.internalPartNo }}</td>

                    <!-- <td>{{ row?.specification }}</td> -->
                    <td class="col-mpns-matchs">
                      <ng-container *ngIf="editingRow === row; else viewspecification">
                        <input class="form-control form-control-sm edit-expand" [(ngModel)]="editableRow.specification">
                      </ng-container>

                      <ng-template #viewspecification>
                        {{ row?.specification }}
                      </ng-template>
                    </td>
                    <!-- <td class="col-mpns">{{ row?.MPN }}</td> -->
                    <td class="col-mpns"
                      [ngClass]="{'mpn-mismatch': row?.MPN !== row?.specification && !isMpnInRelationships(row)}">
                      <span class="mpn-inline">
                        <span class="mpn-text">{{ row?.MPN }}</span>
                        <i class="fa fa-info-circle text-primary cursor-pointer" style="font-size: 13px; flex-shrink: 0;"
                          title="View Sourcing Details" (click)="openMpnInfoPopup(row, mpnInfoModal)">
                        </i>
                      </span>
                    </td>
                    <!-- <td>{{ row?.manufacturer }}</td> -->
                    <!-- <td>
                      <ng-container *ngIf="editingRow === row; else viewmanufacturer">
                        <input class="form-control form-control-sm edit-expand" [(ngModel)]="editableRow.manufacturer">
                      </ng-container>

                      <ng-template #viewmanufacturer>
                        {{ row?.manufacturer }}

                      </ng-template>
                    </td> -->
                    <td>
                      <ng-container *ngIf="editingRow === row; else viewmanufacturer">

                        <div class="position-relative">
                          <input type="text" class="form-control form-control-sm edit-manufacturer"
                            [(ngModel)]="editableRow.manufacturer" (input)="onManufacturerInput($event)"
                            (blur)="onManufacturerBlur()" [ngClass]="{'border-danger': isManufacturerInvalid}"
                            autocomplete="off" />

                          <!-- Suggestions Dropdown -->
                          <ul class="dropdown-menu show w-100" *ngIf="manufacturerSuggestions.length > 0">
                            <li class="dropdown-item" *ngFor="let mfg of manufacturerSuggestions"
                              (mousedown)="selectManufacturer(mfg)">
                              {{ mfg }}
                            </li>
                          </ul>
                        </div>

                      </ng-container>

                      <ng-template #viewmanufacturer>
                        {{ row?.manufacturer }}
                      </ng-template>
                    </td>

                    <!-- <td>{{ row?.commodity }}</td> -->
                    <td>
                      <ng-container *ngIf="editingRow === row; else viewCommodity">
                        <input class="form-control form-control-sm edit-expand" [(ngModel)]="editableRow.commodity">
                      </ng-container>

                      <ng-template #viewCommodity>
                        {{ row?.commodity }}
                      </ng-template>
                    </td>

                    <!-- <td>{{ row?.uom }}</td> -->
                    <td>
                      <ng-container *ngIf="editingRow === row; else viewuom">
                        <input class="form-control form-control-sm" [(ngModel)]="editableRow.uom">
                      </ng-container>

                      <ng-template #viewuom>
                        {{ row?.uom }}
                      </ng-template>
                    </td>
                    <!-- <td>{{ row?.projectQty }}</td> -->
                    <td>
                      <ng-container *ngIf="editingRow === row; else viewprojectQty">
                        <input class="form-control form-control-sm" [(ngModel)]="editableRow.projectQty">
                      </ng-container>

                      <ng-template #viewprojectQty>
                        {{ row?.projectQty }}
                      </ng-template>
                    </td>
                    <td>{{ row?.supplier }}</td>
                    <td></td>
                    <td>{{ row?.country
                      }}</td>
                    <td>{{ row?.Inventorylevel }}</td>
                    <td>{{ row?.MOQ }}</td>
                    <td>{{ row?.Closest_Quantity}}</td>
                    <td>{{ getLeadTimeToShow(row) }}</td>
                    <td>{{ row?.Price }}</td>
                    <td>{{ row?.Currency }}</td>
                    <td>{{ row?.ConvertedPrice | number:'1.2-2' }}</td>
                    <td *ngIf="!isAucukumServer">
                      <ng-container *ngIf="isMarkupMode && isAucukumServer; else viewLandingCost">
                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                          [(ngModel)]="landingCostMap[getRowKey(row)]" (ngModelChange)="onLandingCostChange(row)"
                          (keydown)="preventNegativeInput($event)" style="width: 100px; min-width: 80px;" />
                      </ng-container>
                      <ng-template #viewLandingCost>
                        {{ (isAucukumServer && landingCostMap[getRowKey(row)] !== undefined ? landingCostMap[getRowKey(row)] : row?.landing_cost) }}
                      </ng-template>
                    </td>
                    <td *ngIf="!isAucukumServer">{{ calculateMOQCost(row) | number:'1.2-2' }}</td>
                    <td *ngIf="!isAucukumServer">{{ row?.total_value_inr | number:'1.2-2' }}</td>
                    <td class="col-profit " *ngIf="showPercentColumns && !isNgpInstance" style="width:120px;">
                      <ng-container *ngIf="isMarkupMode; else viewMarkup">
                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                          [(ngModel)]="percentMap[getRowKey(row)]" (ngModelChange)="onPercentChange(row)"
                          (keydown)="preventNegativeInput($event)" />
                      </ng-container>
                      <ng-template #viewMarkup>
                        {{ (percentMap[getRowKey(row)] || 0) }}%
                      </ng-template>
                    </td>
                    <td *ngIf="showPercentColumns">
                      <ng-container *ngIf="isMarkupMode && (isAucukumServer || isNgpInstance); else viewUnitSellingPrice">
                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                          [(ngModel)]="unitSellingPriceMap[getRowKey(row)]" (ngModelChange)="onUnitSellingPriceChange(row)"
                          (keydown)="preventNegativeInput($event)" placeholder="0.00" style="width: 100px; min-width: 80px;" />
                      </ng-container>
                      <ng-template #viewUnitSellingPrice>
                        {{ calculateUnitSellingPrice(row) | number:'1.2-2' }}
                      </ng-template>
                    </td>
                    <td *ngIf="showPercentColumns">
                      <ng-container *ngIf="isMarkupMode && (isAucukumServer || isNgpInstance); else viewTotalSellingValue">
                        <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                          [readonly]="isNgpInstance"
                          [(ngModel)]="totalSellingValueMap[getRowKey(row)]" (ngModelChange)="onTotalSellingValueChange(row)"
                          (keydown)="preventNegativeInput($event)" placeholder="0.00" style="width: 110px; min-width: 90px;" />
                      </ng-container>
                      <ng-template #viewTotalSellingValue>
                        {{ calculatePercentValue(row) | number:'1.2-2' }}
                      </ng-template>
                    </td>
                    <td>
                      <a *ngIf="row.isPoExist === 'Yes'" href="javascript:void(0)" (click)="onPoDataClick(row)">
                        Available
                      </a>

                      <span *ngIf="row.isPoExist !== 'Yes'" style="font-weight: normal;">
                        No Records
                      </span>

                    </td>

                    <td>
                      <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                      </span>

                      <span class="risk-indicator"
                        [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                      </span>

                      <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                      </span>
                    </td>

                    <td>
                      <ng-container *ngIf="editingRow === row">
                        <div class="edit-action-icons">

                          <i class="fa-solid fa-list-check " title="Criteria"
                            (click)="selectCriteria(criteriaModal)"></i>
                          <!-- Save -->
                          <i *ngIf="!isSavingRowEdit" class="fa-solid fa-check text-success" title="Save" (click)="saveRowEdit()"></i>
                          <i *ngIf="isSavingRowEdit" class="fa-solid fa-spinner fa-spin text-success" title="Saving changes..."></i>

                          <!-- Cancel -->
                          <i class="fa-solid fa-xmark text-danger" title="Cancel" (click)="cancelRowEdit()"></i>

                          <i *ngIf="deletingRowIpn !== row.internalPartNo" class="fa-solid fa-trash text-danger ms-2" title="Delete Part" (click)="deleteRow(row)"></i>
                          <i *ngIf="deletingRowIpn === row.internalPartNo" class="fa-solid fa-spinner fa-spin text-danger ms-2" title="Deleting..."></i>
                        </div>
                      </ng-container>
                    </td>


                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <!-- <mat-tab label="PART PULSE">
    <div>
      
      <ngx-analysis></ngx-analysis>

    </div>
  </mat-tab> -->
  <mat-tab label="COMPARE">
    <div class="compare-tab">

      <!-- Controls Row -->
      <div class="compare-controls">

        <!-- Compare Panel -->
        <div class="compare-panel">
          <div class="compare-panel__header">
            <div class="compare-panel__badge compare-panel__badge--left">
              <i class="fa fa-columns compare-panel__badge-icon"></i>
              <span>Compare</span>
            </div>
            <div class="compare-panel__selectors">
              <select [(ngModel)]="compareStageType" (change)="onCompareStageChange()" class="compare-select">
                <option value="Costing">Costing</option>
                <option value="Procurement">Procurement</option>
              </select>
              <select *ngIf="compareStageType === 'Costing'" [(ngModel)]="compareVersionId"
                (change)="onCompareVersionChange()" class="compare-select">
                <option *ngFor="let version of availableVersions" [ngValue]="version">V{{ version }}</option>
              </select>
              <select *ngIf="compareStageType === 'Procurement'" [(ngModel)]="compareVersionId"
                (change)="onCompareVersionChange()" class="compare-select">
                <option *ngFor="let version of availableProcurementVersions" [ngValue]="version">V{{ version }}</option>
              </select>
            </div>
          </div>
          <div class="compare-panel__stats">
            <div class="compare-stat">
              <i class="fa fa-cubes compare-stat__icon compare-stat__icon--blue"></i>
              <span class="compare-stat__label">Parts</span>
              <span class="compare-stat__value">{{ uniquePartsSize }}</span>
            </div>
            <div class="compare-stat">
              <i class="fa fa-check-circle compare-stat__icon compare-stat__icon--green"></i>
              <span class="compare-stat__label">Sourced</span>
              <span class="compare-stat__value">{{ partsExceptNACompare }}</span>
            </div>
            <div class="compare-stat">
              <i class="fa fa-inr compare-stat__icon compare-stat__icon--purple"></i>
              <span class="compare-stat__label">Cost</span>
              <span class="compare-stat__value">₹ {{ totalSuminCompare | number:'1.0-0' }}</span>
            </div>
          </div>
        </div>

        <!-- With Panel -->
        <div class="compare-panel">
          <div class="compare-panel__header">
            <div class="compare-panel__badge compare-panel__badge--right">
              <i class="fa fa-exchange compare-panel__badge-icon"></i>
              <span>With</span>
            </div>
            <div class="compare-panel__selectors">
              <select [(ngModel)]="withStageType" (change)="onWithStageChange()" class="compare-select">
                <option value="Costing">Costing</option>
                <option value="Procurement">Procurement</option>
              </select>
              <select *ngIf="withStageType === 'Costing'" [(ngModel)]="withVersionId" (change)="onWithVersionChange()"
                class="compare-select">
                <option *ngFor="let version of availableVersions" [ngValue]="version">V{{ version }}</option>
              </select>
              <select *ngIf="withStageType === 'Procurement'" [(ngModel)]="withVersionId"
                (change)="onWithVersionChange()" class="compare-select">
                <option *ngFor="let version of availableProcurementVersions" [ngValue]="version">V{{ version }}</option>
              </select>
            </div>
          </div>
          <div class="compare-panel__stats">
            <div class="compare-stat">
              <i class="fa fa-cubes compare-stat__icon compare-stat__icon--blue"></i>
              <span class="compare-stat__label">Parts</span>
              <span class="compare-stat__value">{{ uniquePartsWith }}</span>
            </div>
            <div class="compare-stat">
              <i class="fa fa-check-circle compare-stat__icon compare-stat__icon--green"></i>
              <span class="compare-stat__label">Sourced</span>
              <span class="compare-stat__value">{{ partsExceptNAWith }}</span>
            </div>
            <div class="compare-stat">
              <i class="fa fa-inr compare-stat__icon compare-stat__icon--purple"></i>
              <span class="compare-stat__label">Cost</span>
              <span class="compare-stat__value">₹ {{ totalSuminwith | number:'1.0-0' }}</span>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- Tables Grid -->
      <div class="compare-tables-grid">

        <!-- Left Table (Compare) -->
        <div class="compare-table-wrap">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive gd_main_div_mobile">
                <table class="table table-striped custom-hover">
                  <thead>
                    <tr>
                      <th>MPN</th>
                      <th>Make</th>
                      <th>Supplier</th>
                      <th>Stock</th>
                      <th>UOM</th>
                      <th>Price</th>
                      <th>UOC</th>
                      <th>MOQ</th>
                       <th>Landing Cost</th>
                      <th>Lead Time</th>
                      <!-- <th>ABC Rating</th> -->
                     
                      <th>Total Cost (INR)</th>
                      <th>Risk (Inv,LT,Price)</th>
                      <th>IPN</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let itemList of filteredFirstTableData">
                      <tr *ngFor="let row of itemList.parts"
                        [ngClass]="{ 'highlight-row': row.internalPartNo === highlightedIpn }">
                        <td class="td-truncate" [title]="row?.MPN">{{ row?.MPN }}</td>
                        <td class="td-truncate" [title]="row?.manufacturer">{{ row?.manufacturer }}</td>
                        <td>{{ row?.supplier }}</td>
                        <td>{{ row?.Inventorylevel }}</td>
                        <td>{{ row?.uom }}</td>
                        <td>{{ row?.Price | number:'1.2-2' }}</td>
                        <td>{{ row?.Currency }}</td>
                        <td>{{ row?.MOQ }}</td>
                         <td>{{ row?.landing_cost }}</td>
                        <td>{{ row?.leadTime }}</td>
                        <!-- <td>{{ row?.abcRating }}</td> -->
                       
                        <td>{{ row?.total_value_inr | number:'1.2-2' }}</td>
                        <td>
                          <span class="risk-indicator"
                            [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                          </span>
                          <span class="risk-indicator"
                            [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                          </span>
                          <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                          </span>
                        </td>
                        <td>
                          {{ row.internalPartNo }}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Right Table (With) -->
        <div class="compare-table-wrap">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive gd_main_div_mobile">
                <table class="table table-striped custom-hover">
                  <thead>
                    <tr>
                      <th>IPN</th>
                      <th>MPN</th>
                      <th>Make</th>
                      <th>Supplier</th>
                      <th>Stock</th>
                      <th>UOM</th>
                      <th>Price</th>
                      <th>UOC</th>
                      <th>MOQ</th>
                      <th>Landing Cost</th>
                      <th>Lead Time</th>
                      <!-- <th>ABC Rating</th> -->
                      
                      <th>Total Cost (INR)</th>
                      <th>Risk (Inv,LT,Price)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let itemList of filteredSecondTableData">
                      <tr *ngFor="let row of itemList.parts">
                        <td (click)="onIpnClick(row.internalPartNo)" style="cursor: pointer; color: blue; text-decoration: underline;">
                          {{ row?.internalPartNo }}
                        </td>
                        <td class="td-truncate" [title]="row?.MPN">{{ row?.MPN }}</td>
                        <td class="td-truncate" [title]="row?.manufacturer">{{ row?.manufacturer }}</td>
                        <td>{{ row?.supplier }}</td>
                        <td>
                          {{ row?.Inventorylevel }}
                          <span *ngIf="getStockComparisonArrow(row) === 'up'" class="arrow up stock-up stock-change">
                            +{{ getStockDifference(row) }}
                          </span>
                          <span *ngIf="getStockComparisonArrow(row) === 'down'"
                            class="arrow down stock-down stock-change">
                            {{ getStockDifference(row) }}
                          </span>
                        </td>
                        <td>{{ row?.uom }}</td>
                        <td>{{ row?.Price | number:'1.2-2' }}</td>
                        <td>{{ row?.Currency }}</td>
                        <td>{{ row?.MOQ }}</td>
                           <td>
                          {{ row?.landing_cost }}
                          <span *ngIf="getLandingCostArrow(row) === 'up'" class="arrow up price-up stock-change">
                            +₹{{ getLandingCostDifference(row) }}
                          </span>
                          <span *ngIf="getLandingCostArrow(row) === 'down'" class="arrow down price-down stock-change">
                            ₹{{ getLandingCostDifference(row) }}
                          </span>
                        </td>
                        <td>{{ row?.leadTime }}</td>
                        <!-- <td>{{ row?.abcRating }}</td> -->
                     
                        <td>{{ row?.total_value_inr | number:'1.2-2' }}</td>
                        <td>
                          <span class="risk-indicator"
                            [ngStyle]="{ 'background-color': getRiskColor(row.projectQty, row.Inventorylevel) }">
                          </span>
                          <span class="risk-indicator"
                            [ngStyle]="{ 'background-color': getLeadTimeColor(row.projectQty, row.Inventorylevel, row.leadTime) }">
                          </span>
                          <span class="risk-indicator" [ngStyle]="{ 'background-color': row.priceColor }">
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #offerPriceModal let-modal>
  <div class="submit-modal-wrapper">

    <!-- Header -->
    <div class="submit-modal-header">
      <div class="submit-modal-icon-wrap">
        <i class="fa fa-paper-plane"></i>
      </div>
      <div>
        <h5 class="submit-modal-title">Submit Project</h5>
        <p class="submit-modal-subtitle">This action will close the project for further edits</p>
      </div>
      <button class="submit-modal-close-btn" (click)="closePopup()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="submit-modal-body">
      <div class="submit-modal-alert">
        <i class="fa fa-exclamation-triangle submit-modal-alert-icon"></i>
        <div>
          <p class="submit-modal-alert-title">Are you sure you want to close this project?</p>
          <p class="submit-modal-alert-desc">Once submitted, the project status will be updated and no further sourcing
            changes can be made.</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="submit-modal-footer">
      <button type="button" class="submit-modal-btn submit-modal-btn--cancel" (click)="closePopup()">
        <i class="fa fa-times submit-modal-btn__icon"></i> No, Cancel
      </button>
      <button type="submit" class="submit-modal-btn submit-modal-btn--confirm" [disabled]="isProjectNameDuplicate || isSubmittingProject"
        (click)="saveProjectViewData()">
        <span *ngIf="isSubmittingProject" class="spinner-border spinner-border-sm me-1" role="status"></span>
        <i *ngIf="!isSubmittingProject" class="fa fa-check submit-modal-btn__icon"></i> Yes, Submit
      </button>
    </div>

  </div>
</ng-template>

<ng-template #mpnInfoModal let-modal>
  <div class="submit-modal-wrapper" cdkDrag cdkDragRootElement=".modal-content">
    <div class="submit-modal-header" cdkDragHandle
      style="background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); border-bottom: 1px solid #7dd3fc; cursor: grab; user-select: none;">
      <div class="submit-modal-icon-wrap" style="background: rgba(2, 132, 199, 0.15); color: #0284c7;">
        <i class="fa fa-info-circle"></i>
      </div>
      <div>
        <h5 class="submit-modal-title" style="color: #0369a1; margin: 0; font-weight: 700; display: flex; align-items: center; gap: 8px;">
          Sourcing Relationships
          <i class="fa fa-arrows-alt" style="font-size: 11px; opacity: 0.5;" title="Drag to move"></i>
        </h5>
        <p class="submit-modal-subtitle" style="color: #0c4a6e; margin: 2px 0 0 0;">Internal Part Number: <strong>{{
            selectedIpnForInfo }}</strong></p>
      </div>
      <button class="submit-modal-close-btn" (click)="modal.dismiss()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="submit-modal-body" style="padding: 20px;">
      <!-- Loading Spinner -->
      <div *ngIf="isLoadingIpnInfo" class="d-flex flex-column align-items-center justify-content-center"
        style="min-height: 150px;">
        <div class="spinner-border text-primary mb-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div class="text-muted fw-semibold">Fetching relationship details...</div>
      </div>

      <!-- Content -->
      <div *ngIf="!isLoadingIpnInfo">
        <!-- Counts Summary Row -->
        <div style="display: flex; gap: 15px; margin-bottom: 20px; justify-content: space-between;">
          <div class="sourcing-stats-card sourcing-stats-card--mpn">
            <h4 class="stat-val">{{ ipnInfoMpnCount }}</h4>
            <span class="stat-lbl">Matching MPNs</span>
          </div>
          <div class="sourcing-stats-card sourcing-stats-card--mfg">
            <h4 class="stat-val">{{ ipnInfoMfgCount }}</h4>
            <span class="stat-lbl">Manufacturers</span>
          </div>
        </div>

        <!-- Relationships Table -->
        <div *ngIf="ipnInfoRelationships.length > 0" class="table-responsive"
          style="max-height: 250px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px;">
          <table class="sourcing-rel-table">
            <thead>
              <tr>
                <th>MPN (Specification)</th>
                <th>Manufacturer</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rel of ipnInfoRelationships"
                [class.highlighted-row]="rel.specification === selectedMpnForInfo">
                <td [class.cell-highlight-mpn]="rel.specification === selectedMpnForInfo"
                  style="word-break: break-all;">
                  {{ rel.specification }}
                  <span *ngIf="rel.specification === selectedMpnForInfo && rel.manufacturer === selectedMfgForInfo"
                    class="active-match-badge">
                    Active Match
                  </span>
                </td>
                <td
                  [class.cell-highlight-mfg]="rel.specification === selectedMpnForInfo || rel.manufacturer === selectedMfgForInfo"
                  style="word-break: break-all;">
                  {{ rel.manufacturer }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- No Relationships Found Alert -->
        <div *ngIf="ipnInfoRelationships.length === 0" class="submit-modal-alert" style="margin-bottom: 0;">
          <i class="fa fa-exclamation-triangle submit-modal-alert-icon"></i>
          <div>
            <p class="submit-modal-alert-title">No Relationships Found</p>
            <p class="submit-modal-alert-desc">No active sourcing relationships are defined for this internal part
              number.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="submit-modal-footer">
      <button type="button" class="submit-modal-btn submit-modal-btn--cancel" (click)="modal.close()">
        Close
      </button>
    </div>
  </div>
</ng-template>

<ng-template #exportFormatModal let-modal>
  <!-- Modal Header -->
  <div class="criteria-modal-header" style="background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); border-bottom: 1px solid #bfdbfe;">
    <div class="criteria-modal-header-left">
      <div class="criteria-modal-icon-wrapper" style="background: linear-gradient(135deg, #2563eb, #1d4ed8);">
        <i class="fas fa-file-export"></i>
      </div>
      <div>
        <h5 class="criteria-modal-title">Export {{ isNgpInstance ? 'Quotation & Data' : 'Data' }}</h5>
        <p class="criteria-modal-subtitle">{{ isNgpInstance ? 'Choose format, customize addresses and quotation notes, and download your report' : 'Choose format to download Supply Sense report' }}</p>
      </div>
    </div>
    <button type="button" class="criteria-modal-close" aria-label="Close" (click)="modal.dismiss()">
      <i class="nb-close"></i>
    </button>
  </div>

  <div class="criteria-modal-body" style="padding: 20px 24px; max-height: calc(85vh - 120px); overflow-y: auto;">
    
    <!-- 1. Format Selection Cards -->
    <div style="margin-bottom: 16px;">
      <label style="font-size: 11.5px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px; display: block;">
        1. Select Export Format
      </label>
      <div class="export-options-grid" style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 14px;">
        
        <!-- Word (.docx) Option -->
        <div class="export-card" (click)="selectedExportFormat = 'docx'" 
             [style.border-color]="selectedExportFormat === 'docx' ? '#2563eb' : '#e2e8f0'"
             [style.background]="selectedExportFormat === 'docx' ? '#eff6ff' : '#ffffff'"
             [style.box-shadow]="selectedExportFormat === 'docx' ? '0 0 0 2px rgba(37, 99, 235, 0.25)' : 'none'"
             style="border: 2px solid #e2e8f0; border-radius: 12px; padding: 14px 12px; text-align: center; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 42px; height: 42px; background: rgba(37, 99, 235, 0.1); color: #2563eb; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin: 0 auto 8px; font-size: 20px;">
            <i class="fas fa-file-word"></i>
          </div>
          <h6 style="margin: 0 0 3px; font-weight: 700; color: #1e293b; font-size: 14px;">Word (.docx)</h6>
          <p style="margin: 0; font-size: 11px; color: #64748b; line-height: 1.3;">{{ isNgpInstance ? 'Quotation template in editable Word document' : 'Standard Word document report layout' }}</p>
          <span *ngIf="selectedExportFormat === 'docx'" class="badge badge-primary mt-2" style="font-size: 10px; background: #2563eb; padding: 3px 8px; font-weight: 600;">Selected</span>
        </div>

        <!-- PDF (.pdf) Option -->
        <div class="export-card" (click)="selectedExportFormat = 'pdf'" 
             [style.border-color]="selectedExportFormat === 'pdf' ? '#ef4444' : '#e2e8f0'"
             [style.background]="selectedExportFormat === 'pdf' ? '#fef2f2' : '#ffffff'"
             [style.box-shadow]="selectedExportFormat === 'pdf' ? '0 0 0 2px rgba(239, 68, 68, 0.25)' : 'none'"
             style="border: 2px solid #e2e8f0; border-radius: 12px; padding: 14px 12px; text-align: center; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 42px; height: 42px; background: rgba(239, 68, 68, 0.1); color: #ef4444; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin: 0 auto 8px; font-size: 20px;">
            <i class="fas fa-file-pdf"></i>
          </div>
          <h6 style="margin: 0 0 3px; font-weight: 700; color: #1e293b; font-size: 14px;">PDF (.pdf)</h6>
          <p style="margin: 0; font-size: 11px; color: #64748b; line-height: 1.3;">{{ isNgpInstance ? 'Printable quotation PDF with address header' : 'Printable document report layout' }}</p>
          <span *ngIf="selectedExportFormat === 'pdf'" class="badge badge-danger mt-2" style="font-size: 10px; background: #ef4444; padding: 3px 8px; font-weight: 600;">Selected</span>
        </div>

        <!-- Excel (.xlsx) Option -->
        <div class="export-card" (click)="selectedExportFormat = 'xlsx'" 
             [style.border-color]="selectedExportFormat === 'xlsx' ? '#10b981' : '#e2e8f0'"
             [style.background]="selectedExportFormat === 'xlsx' ? '#f0fdf4' : '#ffffff'"
             [style.box-shadow]="selectedExportFormat === 'xlsx' ? '0 0 0 2px rgba(16, 185, 129, 0.25)' : 'none'"
             style="border: 2px solid #e2e8f0; border-radius: 12px; padding: 14px 12px; text-align: center; cursor: pointer; transition: all 0.2s ease;">
          <div style="width: 42px; height: 42px; background: rgba(16, 185, 129, 0.1); color: #10b981; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin: 0 auto 8px; font-size: 20px;">
            <i class="fas fa-file-excel"></i>
          </div>
          <h6 style="margin: 0 0 3px; font-weight: 700; color: #1e293b; font-size: 14px;">Excel (.xlsx)</h6>
          <p style="margin: 0; font-size: 11px; color: #64748b; line-height: 1.3;">{{ isNgpInstance ? '15-column Quotation Table spreadsheet' : 'Spreadsheet with full data columns & formatting' }}</p>
          <span *ngIf="selectedExportFormat === 'xlsx'" class="badge badge-success mt-2" style="font-size: 10px; background: #10b981; padding: 3px 8px; font-weight: 600;">Selected</span>
        </div>

      </div>
    </div>

    <!-- 2. Quotation Address & Notes Section (Only for NGP Instance) -->
    <div *ngIf="isNgpInstance" style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; margin-top: 14px;">
      
      <!-- Section Notice -->
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #f1f5f9;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <div style="width: 28px; height: 28px; border-radius: 6px; background: #e0f2fe; color: #0284c7; display: flex; align-items: center; justify-content: center; font-size: 13px;">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div>
            <h6 style="margin: 0; font-size: 13px; font-weight: 700; color: #0f172a;">2. Add &amp; Edit Quotation Addresses</h6>
            <span style="font-size: 11px; color: #64748b;">Add or edit seller &amp; customer billing/shipping details before downloading</span>
          </div>
        </div>

        <div style="display: flex; align-items: center; gap: 8px;">
          <button type="button" class="btn btn-xs btn-outline-primary" (click)="showShippingAddress = !showShippingAddress"
                  style="font-size: 11px; padding: 3px 8px; border-radius: 6px;">
            <i class="fas fa-truck mr-1"></i> {{ showShippingAddress ? '- Hide Shipping Address' : '+ Add Shipping Address' }}
          </button>
          <div style="display: flex; align-items: center; gap: 6px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 20px; padding: 4px 10px;">
            <i class="fas fa-check-circle" style="font-size: 11px; color: #2563eb;"></i>
            <span style="font-size: 11px; font-weight: 600; color: #1e40af;">Editable Address Fields</span>
          </div>
        </div>
      </div>

      <!-- Address Grid: 2 Columns (Seller vs Customer) -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 14px; width: 100%;">
        
        <!-- Column 1: Seller / Company Details -->
        <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px; display: flex; flex-direction: column; gap: 8px;">
          <div style="display: flex; align-items: center; justify-content: space-between; padding-bottom: 6px; border-bottom: 1px dashed #cbd5e1; margin-bottom: 2px;">
            <div style="display: flex; align-items: center; gap: 6px;">
              <i class="fas fa-building" style="color: #2563eb; font-size: 13px;"></i>
              <span style="font-size: 12px; font-weight: 700; color: #1e293b;">From: Company (Seller)</span>
            </div>
            <span style="font-size: 10.5px; color: #64748b; font-weight: 600;">Edit Seller Info</span>
          </div>

          <!-- Company Name -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Company Name</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.sellerCompanyName"
                   style="font-size: 12px; font-weight: 600; border-radius: 6px; width: 100%;" placeholder="Company Name" />
          </div>

          <!-- Company Address -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Company Address</label>
            <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="exportAddress.sellerAddress"
                      style="font-size: 11.5px; border-radius: 6px; resize: vertical; width: 100%;" placeholder="Street, Building, Area, City, Pincode"></textarea>
          </div>

          <!-- GST & Phone (2 cols) -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">GSTIN</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.sellerGst"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="GSTIN" />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Phone</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.sellerPhone"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Phone" />
            </div>
          </div>

          <!-- Email & Sales Agent (2 cols) -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Email</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.sellerEmail"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Email" />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Sales Agent</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.salesAgent"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Agent Name" />
            </div>
          </div>

        </div>

        <!-- Column 2: Customer / Buyer Details -->
        <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px; padding: 14px; display: flex; flex-direction: column; gap: 8px;">
          <div style="display: flex; align-items: center; justify-content: space-between; padding-bottom: 6px; border-bottom: 1px dashed #cbd5e1; margin-bottom: 2px;">
            <div style="display: flex; align-items: center; gap: 6px;">
              <i class="fas fa-user-tag" style="color: #0284c7; font-size: 13px;"></i>
              <span style="font-size: 12px; font-weight: 700; color: #1e293b;">To: Customer / Buyer</span>
            </div>
            <span style="font-size: 10.5px; color: #64748b; font-weight: 600;">Edit Customer Info</span>
          </div>

          <!-- Customer Reference / Name -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Customer Reference / Name</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.customerName"
                   style="font-size: 12px; font-weight: 600; border-radius: 6px; width: 100%;" placeholder="Customer Name or Ref" />
          </div>

          <!-- Customer Address -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Customer Address (Billing)</label>
            <textarea class="form-control form-control-sm" rows="3" [(ngModel)]="exportAddress.buyerAddress"
                      style="font-size: 11.5px; border-radius: 6px; resize: vertical; width: 100%;" placeholder="Customer / Billing Address"></textarea>
          </div>

          <!-- Customer GSTIN -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Customer GSTIN</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.customerGst"
                   style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Customer GST (e.g. 29AADCT6132C1ZJ)" />
          </div>

          <!-- Buyer Name & Phone (2 cols) -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Buyer / Attn Name</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.buyerName"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Contact Person" />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px;">
              <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Buyer Phone</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.buyerPhone"
                     style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="Phone" />
            </div>
          </div>

          <!-- Buyer Email -->
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <label style="font-size: 11px; font-weight: 600; color: #475569; margin: 0;">Buyer Email</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.buyerEmail"
                   style="font-size: 11.5px; border-radius: 6px; width: 100%;" placeholder="buyer@company.com" />
          </div>

          <!-- Dear Mr. (Clean Dedicated Salutation Box) -->
          <div style="display: flex; flex-direction: column; gap: 5px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 8px; padding: 10px 12px; margin-top: 2px;">
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <label style="font-size: 11px; font-weight: 700; color: #1e40af; margin: 0; display: flex; align-items: center; gap: 5px;">
                <i class="fas fa-user-edit"></i> Salutation / Buyer Name (for "Dear Mr. ...")
              </label>
              <span style="font-size: 10px; color: #3b82f6; font-weight: 500;">Word Quotation Letter</span>
            </div>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="exportAddress.salutationName"
                   style="font-size: 11.5px; border-radius: 6px; background: #ffffff; border: 1px solid #93c5fd; width: 100%;" 
                   [placeholder]="exportAddress.buyerName ? 'Using Buyer: ' + exportAddress.buyerName : 'Enter name to appear after Dear Mr. (e.g. Sharma, John)'" />
            <div style="font-size: 10.5px; color: #2563eb; line-height: 1.3; background: #dbeafe; padding: 4px 8px; border-radius: 4px;">
              <i class="fas fa-eye mr-1"></i> Preview: <strong>Dear Mr. {{ exportAddress.salutationName || exportAddress.buyerName || '_______________' }},</strong> Thank you for your valuable RFQ...
            </div>
          </div>

        </div>

      </div>

      <!-- Optional Add Shipping Address -->
      <div *ngIf="showShippingAddress" style="display: flex; flex-direction: column; gap: 4px; background: #f1f5f9; border: 1px dashed #cbd5e1; border-radius: 8px; padding: 10px 12px; margin-top: 12px; width: 100%;">
        <label style="font-size: 11px; font-weight: 700; color: #334155; margin: 0; display: flex; align-items: center; gap: 5px;">
          <i class="fas fa-truck"></i>
          Shipping / Delivery Address (Optional - if different from billing):
        </label>
        <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="exportAddress.shippingAddress"
                  style="font-size: 11px; border-radius: 6px; resize: vertical; background: #ffffff; width: 100%;"
                  placeholder="Enter separate shipping or site delivery address..."></textarea>
      </div>

      <!-- Delivery Terms & Payment Terms (2 Columns) -->
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 12px; width: 100%;">
        <div style="display: flex; flex-direction: column; gap: 4px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 8px; padding: 10px 12px;">
          <label style="font-size: 11px; font-weight: 700; color: #334155; margin: 0; display: flex; align-items: center; gap: 5px;">
            <i class="fas fa-truck text-primary"></i>
            Delivery Terms:
          </label>
          <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="exportAddress.deliveryTerms"
                    style="font-size: 11px; border-radius: 6px; resize: vertical; background: #ffffff; border: 1px solid #94a3b8; width: 100%;"
                    placeholder="e.g. Ex-Works / Standard Delivery Schedule as quoted."></textarea>
        </div>
        <div style="display: flex; flex-direction: column; gap: 4px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 8px; padding: 10px 12px;">
          <label style="font-size: 11px; font-weight: 700; color: #334155; margin: 0; display: flex; align-items: center; gap: 5px;">
            <i class="fas fa-credit-card text-success"></i>
            Payment Terms:
          </label>
          <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="exportAddress.paymentTerms"
                    style="font-size: 11px; border-radius: 6px; resize: vertical; background: #ffffff; border: 1px solid #94a3b8; width: 100%;"
                    placeholder="e.g. Net 30 days subject to finance approval / 100% advance for new customers."></textarea>
        </div>
      </div>

      <!-- PO Placement Address (Terms & Conditions) -->
      <div style="display: flex; flex-direction: column; gap: 4px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 10px 12px; margin-top: 12px; width: 100%;">
        <label style="font-size: 11px; font-weight: 700; color: #92400e; margin: 0; display: flex; align-items: center; gap: 5px;">
          <i class="fas fa-file-contract"></i>
          PO Placement Address (Terms &amp; Conditions):
        </label>
        <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="exportAddress.poPlacementAddress"
                  style="font-size: 11px; border-radius: 6px; resize: vertical; background: #ffffff; border: 1px solid #fcd34d; width: 100%;"
                  placeholder="Purchase Orders must be placed in the name of..."></textarea>
      </div>

      <!-- Quotation Notes Box (Clean, Structured, Vertical Flow) -->
      <div style="display: flex; flex-direction: column; gap: 10px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; padding: 14px; margin-top: 14px; width: 100%;">
        
        <!-- Header -->
        <div style="display: flex; align-items: center; justify-content: space-between; border-bottom: 1px dashed #86efac; padding-bottom: 8px;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <i class="fas fa-sticky-note" style="color: #16a34a; font-size: 14px;"></i>
            <span style="font-size: 12.5px; font-weight: 700; color: #166534;">Quotation Notes</span>
            <span style="font-size: 11px; color: #15803d; font-weight: 400;">(Printed line-by-line in Quotation Notes box in Word &amp; PDF)</span>
          </div>
        </div>

        <!-- Quick Preset Add Note Chips -->
        <div style="display: flex; flex-wrap: wrap; gap: 6px; align-items: center;">
          <span style="font-size: 10.5px; color: #166534; font-weight: 700;">Quick Add:</span>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Quotation validity: 30 days from date of issue.')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + 30 Days Validity
          </button>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Delivery schedule: 4 to 6 weeks from PO confirmation.')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + Delivery 4-6 Wks
          </button>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Payment terms: Net 30 days subject to credit approval.')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + Net 30 Days
          </button>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Payment terms: 100% advance along with Purchase Order.')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + 100% Advance
          </button>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Parts are subject to prior stock availability.')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + Stock Availability
          </button>
          <button type="button" class="btn btn-xs btn-outline-success" (click)="appendQuotationNote('Order is Non-Cancellable and Non-Returnable (NCNR).')"
                  style="font-size: 10.5px; padding: 3px 9px; border-radius: 12px; background: #ffffff; border-color: #86efac; color: #15803d;">
            + NCNR Terms
          </button>
        </div>

        <!-- Editable Notes Textarea with Helpful Tip -->
        <div style="display: flex; flex-direction: column; width: 100%; gap: 4px;">
          <textarea class="form-control form-control-sm" rows="4" [(ngModel)]="exportAddress.quotationNotes"
                    style="font-size: 11.5px; border-radius: 6px; resize: vertical; background: #ffffff; border: 1px solid #86efac; width: 100%; line-height: 1.5;"></textarea>
          <span style="font-size: 10px; color: #15803d;">
            <i class="fas fa-info-circle mr-1"></i> Each line above will print directly inside the <strong>Quotation Notes</strong> box in Word &amp; PDF.
          </span>
        </div>

      </div>

    </div>

    <!-- Quotation Items & Remarks Table (Editable Remarks) -->
    <div style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 16px; margin-top: 14px;">
      
      <!-- Section Header -->
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; padding-bottom: 10px; border-bottom: 1px solid #f1f5f9;">
        <div style="display: flex; align-items: center; gap: 8px;">
          <div style="width: 28px; height: 28px; border-radius: 6px; background: #fef3c7; color: #d97706; display: flex; align-items: center; justify-content: center; font-size: 13px;">
            <i class="fas fa-list-alt"></i>
          </div>
          <div>
            <h6 style="margin: 0; font-size: 13px; font-weight: 700; color: #0f172a;">
              {{ isNgpInstance ? '3. Quotation Items & Remarks' : '2. Items & Remarks to Export' }}
            </h6>
            <span style="font-size: 11px; color: #64748b;">
              Review items and add or edit remarks for each part to be included in the export
            </span>
          </div>
        </div>

        <div>
          <span class="badge badge-light" style="font-size: 11px; border: 1px solid #cbd5e1; padding: 5px 9px; font-weight: 600; color: #334155; border-radius: 6px;">
            Total Items: {{ exportItems.length }}
          </span>
        </div>
      </div>

      <!-- Items Table -->
      <div style="max-height: 320px; overflow-y: auto; border: 1px solid #e2e8f0; border-radius: 8px;">
        <table class="table table-sm table-hover mb-0" style="font-size: 11.5px; width: 100%;">
          <thead style="background: #f8fafc; position: sticky; top: 0; z-index: 2; box-shadow: 0 1px 2px rgba(0,0,0,0.05);">
            <tr style="color: #475569; font-size: 11px; text-transform: uppercase;">
              <th style="width: 45px; text-align: center; padding: 8px 6px;">#</th>
              <th style="min-width: 140px; padding: 8px 6px;">Part No / MPN</th>
              <th style="min-width: 150px; padding: 8px 6px;">Description</th>
              <th style="width: 65px; text-align: right; padding: 8px 6px;">Qty</th>
              <th style="width: 105px; text-align: right; padding: 8px 6px;">Unit Price (₹)</th>
              <th style="width: 110px; text-align: right; padding: 8px 6px;">Total (₹)</th>
              <th style="min-width: 200px; padding: 8px 6px;">
                <span style="display: flex; align-items: center; gap: 4px; color: #2563eb;">
                  <i class="fas fa-comment-dots"></i> Remarks (Add / Edit)
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of exportItems; let i = index">
              <td style="text-align: center; vertical-align: middle; color: #64748b; font-weight: 600;">
                {{ item.slNo || (i + 1) }}
              </td>

              <!-- Part No / MPN -->
              <td style="vertical-align: middle;">
                <div style="font-weight: 600; color: #1e293b;">{{ item.partNumber || item.quotedPart || '-' }}</div>
                <div *ngIf="item.quotedPart && item.quotedPart !== item.partNumber" style="font-size: 10.5px; color: #64748b;">
                  MPN: {{ item.quotedPart }}
                </div>
              </td>

              <!-- Description -->
              <td style="vertical-align: middle;">
                <span class="text-truncate d-inline-block" style="max-width: 180px;" [title]="item.description">
                  {{ item.description || '-' }}
                </span>
              </td>

              <!-- Qty -->
              <td style="text-align: right; vertical-align: middle;">
                {{ item.quantity | number }}
              </td>

              <!-- Unit Price -->
              <td style="text-align: right; vertical-align: middle;">
                {{ item.unitPrice | currency:'INR':'symbol':'1.2-2' }}
              </td>

              <!-- Total Price -->
              <td style="text-align: right; vertical-align: middle; font-weight: 600; color: #0f172a;">
                {{ item.totalPrice | currency:'INR':'symbol':'1.2-2' }}
              </td>

              <!-- Remarks Input Field (Edit and Add) -->
              <td style="vertical-align: middle;">
                <input type="text" class="form-control form-control-sm" [(ngModel)]="item.remarks" 
                       (ngModelChange)="onExportRemarkChange(item)"
                       placeholder="+ Add / edit remark..." 
                       style="font-size: 11px; border-radius: 6px; padding: 3px 8px; border: 1px solid #cbd5e1; background: #ffffff;" />
              </td>
            </tr>

            <tr *ngIf="exportItems.length === 0">
              <td colspan="7" class="text-center py-3 text-muted" style="font-size: 12px;">
                No items available in export.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

  </div>

  <!-- Modal Footer -->
  <div class="criteria-modal-footer" style="padding: 12px 24px; display: flex; align-items: center; justify-content: space-between; border-top: 1px solid #e2e8f0; background: #ffffff;">
    <div>
      <button *ngIf="isNgpInstance" type="button" class="btn btn-outline-secondary btn-sm" (click)="resetExportToDefaults()" 
              style="font-size: 11.5px; border-radius: 6px;">
        <i class="fas fa-undo mr-1"></i> Reset to Defaults
      </button>
    </div>

    <div style="display: flex; align-items: center; gap: 10px;">
      <button type="button" class="criteria-btn-secondary" (click)="modal.dismiss()" style="border-radius: 6px; font-size: 12px;">
        Cancel
      </button>
      <button type="button" class="criteria-btn-primary" (click)="downloadExport()" [disabled]="isExporting"
              style="border-radius: 6px; font-size: 12px; padding: 7px 20px;">
        <i *ngIf="isExporting" class="fas fa-spinner fa-spin mr-1"></i>
        <i *ngIf="!isExporting" class="fas fa-download mr-1"></i>
        <span>{{ isExporting ? 'Generating...' : ('Download ' + (selectedExportFormat | uppercase)) }}</span>
      </button>
    </div>
  </div>
</ng-template>
<!-- Top Ambient Glowing Shimmer -->
<div *ngIf="isLoading" class="loading-bar"></div>

<!-- Super Modern Loading Overlay -->
<div *ngIf="isLoading" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-cube sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">{{ loadingTitle }}</h4>
      <p class="sb-loading-subtitle">{{ loadingSubtitle }}</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>